	<app-inline-confirmation (confirm)="_confirm($event)" (cancelEvent)="_cancel($event)" [trigger]="trigger()" [shouldCloseOnEmit]="shouldCloseOnEmit()">
			<app-inline-confirmation-message>
				Wirklich löschen?
			</app-inline-confirmation-message>
			<app-inline-confirmation-operators>
				<button mat-button appInlineConfirmationConfirm class="inline-confirmation__delete">
					<ogs-m3-icon matButtonIcon icon="trash-can"/>
				 Löschen
				</button>
				<button mat-button appInlineConfirmationCancel>
					Abbrechen
				</button>
			</app-inline-confirmation-operators>
		</app-inline-confirmation>